import { Visibility, VisibilityOff } from '@mui/icons-material'
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  Input as MUIInput
} from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField'
import { useState } from 'react'
import styled from '@emotion/styled'
import { useTextFieldStyles } from './TextFieldStyles'

// ── Rounded-box style (SignIn page) ──────────────────────────────────────────

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 15px;
`

const InputRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`

const StyledInput = styled.input`
  all: unset;
  background: ${(p: any) => p.theme?.colors?.darkGrey ?? '#1C1C1C'};
  box-shadow: 9px 9px 18px rgba(0, 0, 0, 0.1);
  border-radius: 7.2px;
  border: none;
  height: 50px;
  padding-left: 20px;
  padding-right: 52px;
  color: white;
  flex: 1;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }
`

const ToggleButton = styled(IconButton)`
  position: absolute;
  right: 8px;
`

const ErrorText = styled.div`
  text-align: left;
  margin-left: 5px;
  font-size: 12px;
  color: #df301a;
`

// ── Dashed-underline style (Create Account / form pages) ─────────────────────

type Props = TextFieldProps & { inputVariant?: 'standard' }

export const TextFieldPassword = ({ inputVariant, ...props }: Props) => {
  const classes = useTextFieldStyles()
  const [hidden, setHidden] = useState(true)

  const eyeIcon = (
    <InputAdornment position="end">
      <IconButton onClick={() => setHidden(!hidden)} tabIndex={-1}>
        {hidden ? (
          <Visibility sx={{ color: '#307ec5' }} />
        ) : (
          <VisibilityOff sx={{ color: '#307ec5' }} />
        )}
      </IconButton>
    </InputAdornment>
  )

  if (inputVariant === 'standard') {
    return (
      <div className={classes.root}>
        <FormControl variant="standard" error={props.error}>
          <InputLabel>{props.label}</InputLabel>
          <MUIInput
            onChange={props.onChange}
            onBlur={props.onBlur}
            name={props.name}
            inputRef={props.inputRef}
            value={props.value}
            type={hidden ? 'password' : 'text'}
            endAdornment={eyeIcon}
          />
          <FormHelperText>{props.helperText}</FormHelperText>
        </FormControl>
      </div>
    )
  }

  return (
    <Wrapper>
      <InputRow>
        <StyledInput
          type={hidden ? 'password' : 'text'}
          placeholder={props.label as string}
          name={props.name}
          onChange={props.onChange as any}
          onBlur={props.onBlur as any}
          ref={props.inputRef as any}
          value={props.value as any}
        />
        <ToggleButton onClick={() => setHidden(!hidden)} tabIndex={-1}>
          {hidden ? (
            <Visibility sx={{ color: '#307ec5' }} />
          ) : (
            <VisibilityOff sx={{ color: '#307ec5' }} />
          )}
        </ToggleButton>
      </InputRow>
      {props.helperText && <ErrorText>{props.helperText}</ErrorText>}
    </Wrapper>
  )
}
